import React from 'react';
import { linkifySirati } from './siratiLinks';

export const ISLAMOJI_SHORTCODE = /:([a-zA-Z0-9_-]+):/g;

// Splits a line of text on :shortcode: patterns, rendering any that match a
// known Islamoji as a small inline image. Used for posts, comments/replies,
// and direct messages.
export const renderLineWithIslamojis = (line, islamojiMap) => {
  if (!line) return line;
  if (!islamojiMap || Object.keys(islamojiMap).length === 0) return linkifySirati(line);
  const parts = line.split(ISLAMOJI_SHORTCODE);
  if (parts.length === 1) return linkifySirati(line);
  return parts.map((part, i) => {
    // Odd indices are the captured shortcode names (from the split regex)
    if (i % 2 === 1) {
      const emoji = islamojiMap[part.toLowerCase()];
      if (emoji) {
        return (
          <img
            key={i}
            src={emoji.image_url}
            alt={`:${part}:`}
            className="inline-block w-5 h-5 align-text-bottom mx-0.5"
          />
        );
      }
      return `:${part}:`;
    }
    const linked = linkifySirati(part);
    return Array.isArray(linked) ? <React.Fragment key={i}>{linked}</React.Fragment> : linked;
  });
};

// Returns the matching Islamoji if `content` is ONLY a single :shortcode:
// (nothing else, no extra text) — used to render lone-emoji messages as a
// bigger "sticker" instead of a small inline image.
export const getSoloIslamoji = (content, islamojiMap) => {
  if (!content || !islamojiMap) return null;
  const match = content.trim().match(/^:([a-zA-Z0-9_-]+):$/);
  if (!match) return null;
  return islamojiMap[match[1].toLowerCase()] || null;
};

// "Sayings" Islamojis posted alone in a comment or reply render 15% larger than
// other solo Islamojis. Returns an inline size override, or undefined for the rest.
export const soloSayingStyle = (item, basePx) => {
  if (item?.category !== 'sayings') return undefined;
  const size = Math.round(basePx * 1.15);
  return { width: size, height: size };
};
